$(() => {
  $('[data-id=dont-see-more]').on('click', function() {
    $('.untruncated').hide();
    $('.truncated').css({ cssText: 'display: block !important;' });
  });
});
